export default {
  // Page title
  'page.title': 'Stoppuhr',

  // How to use
  'howto.title': 'Wie zu Verwenden',
  'howto.step1': 'Klicken Sie auf die Schaltfläche "Start", um die Stoppuhr zu starten, Anzeigeformat: Minuten:Sekunden.Hundertstelsekunden',
  'howto.step2': 'Klicken Sie auf "Pause", um die Zeitmessung anzuhalten, wenn die Stoppuhr läuft, klicken Sie erneut auf "Start", um fortzufahren',
  'howto.step3': 'Klicken Sie auf die Schaltfläche "Zurücksetzen", um die Stoppuhr auf Null zurückzusetzen und die Zeitmessung zu stoppen',
  'howto.step4': 'Die Stoppuhr unterstützt die Anzeige mit Millisekunden-Präzision, geeignet für Szenarien, die eine präzise Zeitmessung erfordern',

  // User reviews
  'reviews.title': 'Benutzerbewertungen',
  'reviews.michaelRunner': 'Unverzichtbares Trainingswerkzeug! Die Millisekunden-Präzision ermöglicht es mir, jede Sprint-Leistung genau aufzuzeichnen, einfache und schnelle Bedienung.',
  'reviews.chefJohnson': 'Magie des Küchen-Timers! Braten, Nudeln kochen, Eier dämpfen, alles erfordert eine präzise Zeitmessung, diese Stoppuhr hilft mir, perfekte Gerichte zuzubereiten.',
  'reviews.sarahStudent': 'Unverzichtbar für Prüfungssimulationen! Wird verwendet, um die Antwortzeit zu üben, die übersichtliche Oberfläche lenkt nicht ab, verbesserte Antwort-Effizienz.',
  'reviews.coachWilliams': 'Hervorragender Assistent für Trainingskurse! Intervalltraining und Planks erfordern eine präzise Zeitmessung, die Studenten lieben es.',
  'reviews.drAnderson': 'Medizinische Arbeit erfordert oft eine präzise Zeitmessung, diese Stoppuhr ist einfach und zuverlässig, ein großartiger Assistent für meine klinische Arbeit.',

  // User names
  'user.michaelRunner': 'Michael Läufer',
  'user.chefJohnson': 'Chefkoch Johnson',
  'user.sarahStudent': 'Sarah Studentin',
  'user.coachWilliams': 'Trainer Williams',
  'user.drAnderson': 'Dr. Anderson',

  // Keywords section
  'keywords.stopwatch': 'Stoppuhr Timer präzise Zeitmessung wie spät ist es jetzt',
  'keywords.chinese': '秒表 计时器 精确计时 现在几点',
  'keywords.japanese': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.spanish': 'cronómetro temporizador tiempo preciso qué hora',
  'keywords.german': 'Stoppuhr Timer präzise Zeit wie spät',
  'keywords.french': 'chronomètre minuteur temps précis quelle heure',
  'keywords.russian': 'секундомер таймер точное время который час',
};
